import { ReactNode } from "react";

/**
 * Wraps public-facing website pages with the .website-theme class,
 * which restores the red brand CTA colors (vs. the neutral admin palette).
 */
export default function WebsiteThemeWrapper({ children }: { children: ReactNode }) {
  return <div className="website-theme">{children}</div>;
}
